var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("抱歉，您访问的页面不存在。")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goToHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }